import { render, staticRenderFns } from "./MeasurementSpecificationTemplateDeleteModal.vue?vue&type=template&id=ef1acad8"
import script from "./MeasurementSpecificationTemplateDeleteModal.vue?vue&type=script&lang=ts"
export * from "./MeasurementSpecificationTemplateDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports